import * as React from 'react';
import { IStringLocalizer } from '../../../utilities/IStringLocalizer';
import { useLocalizer } from './hooks/useLocalizer';

interface AIHelpFooterProps {
    localizer?: IStringLocalizer;
}

const aiDocAgentHelpUrl = "https://help.exchange.3eco.com/en/articles/14691584-ai-supplier-document-agent";

export const AIHelpFooter: React.FC<AIHelpFooterProps> = ({ localizer }) => {
    const localize = useLocalizer(localizer);

    return (
        <div className="ai-help-footer">
            <span>{localize("Need help?")}</span>
            <a
                href={aiDocAgentHelpUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="ai-help-footer-link"
            >
                {localize("Learn More")}
            </a>
            <span>{localize("or")}</span>
            <a href="mailto:support@3eco.com" className="ai-help-footer-link">
                {localize("Contact Support")}
            </a>
            <span>.</span>
        </div>
    );
};

export default AIHelpFooter;
